<template>
  <div>
    <h1>Resources</h1>
  </div>
</template>
<script>
  export default {
    name: 'Resources'
  }
</script>


// WEBPACK FOOTER //
// src/pages/Resources.vue